// Module I/O interchange
import Header from './Header'
import MainNav from './MainNav'
import CookieWidget from './CookieWidget'
import SearchBar from './SearchBar'
import GtmEvents from './GtmEvents'

export {
    Header,
    MainNav,
    CookieWidget,
    SearchBar,
    GtmEvents
}



// WEBPACK FOOTER //
// ./js/core/index.js